import { FetchResult, isFetchResultSuccessful } from '@/entities/FetchResult'
import { NotificationCenterLog } from '@/entities/NotificationCenter/NotificationCenter'

// Starting the event log is best effort: when it fails, the action still runs, just without the event log header
export const getEventLogTrackerData = (result: FetchResult<NotificationCenterLog, string>): NotificationCenterLog | undefined => (
    isFetchResultSuccessful(result) ? result.data : undefined
)
